import React from 'react';
import { SpheraModal } from '@sphera-cloud/component-ui-reactjs';
import { SpheraSpinner } from "@sphera-cloud/component-ui-reactjs";

export function UnArchiveDocumentsModal(props) {
    const loadingPanel = (
        <div className="k-loading-mask">
            <span className="k-loading-text">{props.localizations.Loading}</span>
            <SpheraSpinner version={1} color="dark-1" />
        </div>
    );

    return (
        <div>
            {props.showUnArchiveDocumentsModal && (
                <SpheraModal className="UnArchiveDocumentsModal" title={props.localizations.UnarchiveDocuments} width={450} height={300}
                    onClose={props.toggleUnArchiveDocuments}
                    onCancel={props.toggleUnArchiveDocuments}
                    cancelText={props.localizations.Cancel}
                    actionText={props.localizations.Save}
                    onAction={props.submitUnArchiveDocuments}
                >
                    <div className="UnArchiveDocumentsModalDiv" >
                        <div>{props.localizations.UnarchiveDocumentsConfirm}</div>
                        {props.modalPending && loadingPanel}
                    </div>
                </SpheraModal>
            )}
        </div>
    );
}